import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { openSecureUrl, ALLOWED_DOMAINS } from '../../utils/security';

const WhatsAppFloat = ({ currentContent }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  // Mostrar el botón después de un pequeño delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const openWhatsApp = () => {
    const message = encodeURIComponent(currentContent.booking.whatsappMessage);
    const phoneNumber = "543883316388";
    const url = `https://wa.me/${phoneNumber}?text=${message}`;
    
    openSecureUrl(url, ALLOWED_DOMAINS.WHATSAPP);
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Overlay cuando está expandido */}
      {isExpanded && (
        <div 
          className="fixed inset-0 bg-black/20 z-40"
          onClick={() => setIsExpanded(false)}
        />
      )}
      
      {/* Botón flotante */}
      <div className="fixed bottom-6 right-6 z-50">
        {/* Mensaje expandido */}
        {isExpanded && (
          <div className="mb-4 bg-white rounded-2xl shadow-2xl p-4 max-w-xs animate-fadeInUp">
            <div className="flex justify-between items-start mb-2">
              <div className="flex items-center space-x-2">
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                  <MessageCircle className="h-5 w-5 text-white" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900">Casa Colores</p>
                  <p className="text-xs text-gray-500">{currentContent.whatsappFloat.online}</p>
                </div>
              </div>
              <button 
                onClick={toggleExpanded}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
            <p className="text-sm text-gray-700 mb-3">
              {currentContent.whatsappFloat.greeting}
            </p>
            <button
              onClick={openWhatsApp}
              className="w-full bg-green-500 hover:bg-green-600 text-white text-sm font-medium py-2 px-4 rounded-lg transition-colors duration-200"
            >
              {currentContent.whatsappFloat.buttonText}
            </button>
          </div>
        )}

        {/* Botón principal */}
        <button
          onClick={isExpanded ? openWhatsApp : toggleExpanded}
          className="w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 animate-pulse-slow"
          style={{
            animation: isExpanded ? 'none' : 'pulse 2s infinite'
          }}
        >
          <MessageCircle className="h-8 w-8" />
        </button>

        {/* Indicador de notificación */}
        {!isExpanded && (
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center">
            <div className="w-2 h-2 bg-white rounded-full animate-ping"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default WhatsAppFloat;
